import { useState, useEffect } from 'react';
import { Grid, CardContent, Typography } from "@mui/material";
import { Button } from '@gpstrackit/react-controls';
import { useDispatch, useSelector } from 'react-redux';

//Styles
import './index.scss';

//Actions
import {
  deleteGadgetOpenModal
} from 'Redux/actions';

//Views 
import Gadgets from 'Modules/dashboard/views/.components/dashboardPanel/.components/gadgets';

const UserGadget = (props) => {
  const { expandGadget, item, createEdit, editMode, isEditable } = props;
  const dispatch = useDispatch();

  //Local State
  const [update, setUpdate] = useState(0)
  const [exportData, setExportData] = useState(false)
  const [total, setTotal] = useState(0)
  const gadgetInformation = useSelector(state => state.devicesByStatusRedux)

  const gadgetWithCounter = ["DevicesByStatus"]

  useEffect(() => {
    let timeSecond = item.refreshSeconds * 1000;
    const interval = setInterval(() => {
      setUpdate(Date.now());
    }, timeSecond);
    return () => clearInterval(interval);
  }, []);

  item.additionalName = "";

  useEffect(() => {
    if (item && gadgetWithCounter.includes(item?.type)) {
      let total = gadgetInformation[`${item.type}-${item.id}-total`]
      setTotal(total)
    }
  }, [gadgetInformation])
  useEffect(() => {
    if (exportData) setExportData(false)
  }, [exportData])

  return (
    <>
      <Grid className="card-content-container">
        <Grid container>
          <Grid item>
            <Typography className="card-content-label">
              {item.name} {item.additionalName} {gadgetWithCounter.includes(item?.type) ? `(${total})` || 0 : ''}
            </Typography>
          </Grid>
        </Grid>
        <Grid className="card-content-container-icons">
          {!editMode &&
            <>
              {
                item?.type === "DevicesByStatus"
                  ? <Button type="icon" icon="download" className="card-content-icons" onClick={() => setExportData(true)} />
                  : <></>
              }

              <Button
                type="icon"
                icon="refresh"
                className="card-content-icons"
                onClick={() => setUpdate(Date.now())}
              />
              {
                isEditable &&
                <Button
                  type="icon"
                  icon="aspect_ratio"
                  className="card-content-icons"
                  onClick={() => expandGadget(item)}
                />
              }
            </>
          }
          {editMode &&
            <>
              <Button
                type="icon"
                icon="edit"
                className="card-content-icons"
                onClick={() => {
                  createEdit(item);
                }}
              />
              <Button
                type="icon"
                icon="delete"
                className="card-content-icons"
                onClick={() => dispatch(deleteGadgetOpenModal(true, item))}
              />
            </>
          }
        </Grid>
      </Grid>
      <CardContent className={gadgetWithCounter.includes(item?.type) ? "card-content-gadget-table" : "card-content-gadget-chart"}>
        <Gadgets item={item} update={update} exportData={exportData} />
      </CardContent>
    </>
  );
}

export default UserGadget;